import React from 'react';
import { useSelector } from 'react-redux';
import { ActivitiesSimCardContainerSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesSimCardContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { InView } from 'react-intersection-observer';
import { SimCardContent } from 'component/page/detail/MoreInfoSections/SimCardSpecification/SimCardContent';
import { selectSimCardContent } from 'component/page/detail/store/detail.selectors';

export const SimCardSpecificationModular: React.FC = () => {
    const simCardContent = useSelector(selectSimCardContent);

    if (!simCardContent.length) {
        return null;
    }

    const onSeen = (inView: boolean) => {
        if (inView && simCardContent.length > 0) {
            trackElementEvent<ActivitiesSimCardContainerSeenEventActivitiesFieldsV1>(ActivitiesSimCardContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: true,
            });
        }
    };

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            {simCardContent.map((content, index) => (
                <SimCardContent key={index} content={content} index={index} maxItems={simCardContent.length} />
            ))}
        </InView>
    );
};

SimCardSpecificationModular.displayName = 'SimCardSpecificationModular';
